import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {
  CURRENT_RETAILER,
  CURRENT_RETAILER_LOADING,
  CURRENT_RETAILER_TAB,
  CURRENT_RETAILER_UPDATE,
  CURRENT_RETAILER_WAREHOUSES,
} from '../constants/retailerTypes';

const initialState = {
  current: {
    retailer: null,
  },
  warehouses: [],
  isLoading: true,
  currentTab: 'settings',
};

const retailer = (state = initialState, action) => {
  switch (action.type) {
    case CURRENT_RETAILER:
      return {
        ...state,
        current: action.payload,
      };

    case CURRENT_RETAILER_UPDATE:
      return {
        ...state,
        current: {
          ...state.current,
          ...action.payload,
        },
      };

    case CURRENT_RETAILER_WAREHOUSES:
      return {
        ...state,
        warehouses: action.payload,
      };

    case CURRENT_RETAILER_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case CURRENT_RETAILER_TAB:
      return {
        ...state,
        currentTab: action.payload,
      };
    default:
      break;
  }
  return state;
};

const persistConfig = {
  key: 'retailer',
  storage,
  whitelist: ['currentTab'],
};

export default persistReducer(persistConfig, retailer);
